module.exports = __webpack_public_path__ + "img/full.3317b860.svg";